import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useEffect, useRef } from "react";
import { useLocalStorage } from "usehooks-ts";
export const MIN_SIDEBAR_WIDTH = 200;
export const MAX_SIDEBAR_WIDTH = 480;

/**
 * Key/default are exported so the loading skeleton (SidebarSkeleton) can
 * render at the width the real sidebar will restore.
 */
export const SESSION_SIDEBAR_WIDTH_KEY = "assistantSidebarWidth";
export const DEFAULT_SESSION_SIDEBAR_WIDTH = 330;
export function useResizableSidebar() {
  const $ = _c(8);
  const [storedWidth, setSidebarWidth] = useLocalStorage(SESSION_SIDEBAR_WIDTH_KEY, DEFAULT_SESSION_SIDEBAR_WIDTH);
  const sidebarWidth = Math.min(MAX_SIDEBAR_WIDTH, Math.max(MIN_SIDEBAR_WIDTH, storedWidth));
  const [isResizing, setIsResizing] = useState(false);
  const sidebarRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => {
      e.preventDefault();
      setIsResizing(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleResizeMouseDown = t0;
  let t1;
  let t2;
  if ($[1] !== isResizing || $[2] !== setSidebarWidth) {
    t1 = () => {
      if (!isResizing) {
        return;
      }
      let rafId = null;
      let pendingWidth = null;
      const handleMouseMove = e_0 => {
        if (!sidebarRef.current) {
          return;
        }
        const containerRect = sidebarRef.current.getBoundingClientRect();
        const newWidth = e_0.clientX - containerRect.left;
        pendingWidth = Math.max(MIN_SIDEBAR_WIDTH, Math.min(MAX_SIDEBAR_WIDTH, newWidth));
        if (rafId === null) {
          rafId = requestAnimationFrame(() => {
            if (pendingWidth !== null) {
              setSidebarWidth(pendingWidth);
            }
            rafId = null;
          });
        }
      };
      const handleMouseUp = () => {
        if (pendingWidth !== null) {
          setSidebarWidth(pendingWidth);
        }
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }
        setIsResizing(false);
      };
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.userSelect = "none";
      document.body.style.cursor = "col-resize";
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }
      };
    };
    t2 = [isResizing, setSidebarWidth];
    $[1] = isResizing;
    $[2] = setSidebarWidth;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== isResizing || $[6] !== sidebarWidth) {
    t3 = {
      sidebarWidth,
      isResizing,
      sidebarRef,
      handleResizeMouseDown
    };
    $[5] = isResizing;
    $[6] = sidebarWidth;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}